import React, { useState } from "react";
import Header from "../repeat/Header";
import Footer from "../repeat/Footer";
import "./contact.css";
import collage from "./our core team/collge.jpg";
import team1 from './our core team/Mohan.jpg'; 
import team2 from './our core team/dhanusri.jpg';
import team3 from './our core team/lokesh.jpg';
import team4 from './our core team/1Shahul.jpg';


const Contact = () => {
  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    email: "",
    phone: "",
    message: "",
  });

  const [isLoading, setIsLoading] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);

    try {
      const response = await fetch(
        "https://gptkpm.in/backend/contactus/savecontactform.php",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(formData),
        }
      );

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const result = await response.json();
      if (result.status === "success") {
        alert(result.message);
        setFormData({
          firstName: "",
          lastName: "",
          email: "",
          phone: "",
          message: "",
        });
      } else {
        alert(`Error: ${result.message}`);
      }
    } catch (error) {
      console.error("Error submitting form:", error);
      alert("There was an error submitting the form. Please try again later.");
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="contact-main">
      <Header />
      <div className="welcome-section">
        <h2>Welcome To Dr. Y. C James Yen Government Polytechnic, Kuppam!</h2>
        <p>
          Nestled in the serene Yanadipalli Village, our institution is
          dedicated to empowering students with quality technical education and
          holistic growth. If you have any queries or need assistance, feel
          free to connect with us.
        </p>
      </div>
      <div className="image-section">
        <img src={collage} alt="College" />
        <p>
          Dr YC James Yen Government Polytechnic - Kuppam, YANADIPALLI VILLAGE,
          KUPPAM - 517425, CHITTOOR (D.T), ANDHRA PRADESH, PH: 8367799101
        </p>
      </div>
      <div className="contact-section">
        <div className="form-container">
          <h2>Contact Us</h2>
          <p>Chat with our friendly team 24/7—we’re here to help!</p>
          <form className="form-contact" onSubmit={handleSubmit}>
            <div className="input-group">
              <label>First Name</label>
              <input
                type="text"
                name="firstName"
                value={formData.firstName}
                onChange={handleChange}
                placeholder="First name"
                required
              />
            </div>
            <div className="input-group">
              <label>Last Name</label>
              <input
                type="text"
                name="lastName"
                value={formData.lastName}
                onChange={handleChange}
                placeholder="Last name"
                required
              />
            </div>
            <div className="input-group">
              <label>Email</label>
              <input
                type="email"
                name="email"
                value={formData.email}
                onChange={handleChange}
                placeholder="you@company.com"
                required
              />
            </div>
            <div className="input-group">
              <label>Phone</label>
              <input
                type="text"
                name="phone"
                value={formData.phone}
                onChange={handleChange}
                placeholder="+1 (555) 000-0000"
                required
              />
            </div>
            <div className="input-group textarea-1">
              <label>Message</label>
              <textarea
                name="message"
                value={formData.message}
                onChange={handleChange}
                placeholder="Leave us a message..."
                required
              ></textarea>
            </div>
            <button className="submit-button" disabled={isLoading}>
              {isLoading ? "Sending..." : "Send Message"}
            </button>
          </form>
        </div>
        <div className="map-container">
          <iframe
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d4611.774474267688!2d78.31485096683234!3d12.746738290590065!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3badb9b4724635a7%3A0xba036c25d2993df1!2sDr.%20Y%20C%20James%20Yen%20Government%20Polytechnic!5e0!3m2!1sen!2sin!4v1736088408432!5m2!1sen!2sin"
            width="100%"
            height="100%"
            style={{ border: 0 }}
            allowFullScreen=""
            loading="lazy"
          ></iframe>
        </div>
        {/* <div className="content-part">
        <p>
          Dr. Y.C. James Yen Government Rural Polytechnic, Kuppam is the First
          Technical Institution located in an impressive picturesque and serene
          atmosphere at Kuppam, Chittoor Dt., a Tri-junction of Andhra Pradesh,
          Tamil Nadu, and Karnataka States.
        </p>
        <p>
          The Institution is established, sponsored, and managed by the Kuppam
          Rural Electric Co-operative Society Limited, (K.R.E.C.S.Ltd.,) Kuppam,
          a Govt. of India undertaking in 1998. This is the only Technical
          Institution in the entire State of Andhra Pradesh, functioning under
          the Co-operative Sector with financial contribution from the Govt. of
          Andhra Pradesh and the K.R.E.C.S. Ltd., Kuppam. It is approved by the
          A.I.C.T.E. New Delhi and Affiliated to S.B.T.E.T., Hyderabad, A.P. It
          is a Co-education Institute. Later, The institution has been taken over
          by the Government w.e.f. 28.3.2014, and the details of the institution
          have been depicted as prior to taken over and after taken over by the
          Government all the benefits are reaching the poor and downtrodden
          students of this institution.
        </p>
        </div> */}

      </div>
      <section className="team-section">
      <h2>Our Core Team</h2>
      <div className="team">
        <a href="https://ankammohan853.github.io/Portfolio/" className="team-link">
        <div className="team-member">
          <img src={team1} alt="Team Member 1" />
          <div className="team-info">
          <p><strong>A.Mohan</strong> / Diploma</p>
            <p>22101-CM-001</p>
          </div>
        </div>
        </a>
        <div className="team-member">
          <img src={team2} alt="Team Member 2" />
          <div className="team-info">
          <p><strong>Dhanusree</strong> / Diploma</p>
            <p>22101-CM-005</p>
          </div>
        </div>
        <div className="team-member">
          <img src={team3} alt="Team Member 3" />
          <div className="team-info">
          <p><strong>Lokesh</strong> / Diploma</p>
            <p>22101-CM-011</p>
          </div>
        </div>
        <a href="https://shahulabbas.github.io/shahulportfolio/" className="team-link">
        <div className="team-member">
          <img src={team4} alt="Team Member 4"/>
          <div className="team-info">
          <p><strong>Shahul Abbash</strong> / Diploma</p>
            <p>22101-CM-022</p>
          </div>
        </div>
        </a>
      </div>
    </section>
      
      <Footer />
    </div>
  );
};

export default Contact;
